import { render, staticRenderFns } from "./AbUiSelect.vue?vue&type=template&id=2c47b1c9&scoped=true&"
import script from "./AbUiSelect.vue?vue&type=script&lang=js&"
export * from "./AbUiSelect.vue?vue&type=script&lang=js&"
import style0 from "./AbUiSelect.vue?vue&type=style&index=0&id=2c47b1c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c47b1c9",
  null
  
)

export default component.exports